type Contact = { phone?: string | null }

// A dependent (e.g. a child) often has no phone of their own. The person who placed the
// call is then the recipient, exactly as if they had called for themselves.
export function resolveReportRecipient<T extends Contact>(customer?: T | null, caller?: T | null): T | undefined {
    if (customer?.phone) return customer
    if (caller?.phone) return caller
    return undefined
}
